var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9.2428mm",
    height: "9.8072mm",
    viewBox: "0 0 9.2428 9.8072",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-64.667 -81.584)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#f00",
    strokeWidth: 4.2333,
    "aria-label": "X"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.667 91.067c0 0.11289 0.05644 0.31044 0.381 0.32456h1.1712c0.381 0 0.508-0.09878 0.762-0.47978l2.2013-3.2456 2.3424 3.2597c0.19756 0.28222 0.29633 0.46567 0.762 0.46567h1.2418c0.31044-0.01411 0.381-0.18344 0.381-0.31044 0-0.14111-0.11289-0.28222-0.19756-0.39511l-3.4854-4.5014 2.8928-3.9229c0.07056-0.09878 0.16933-0.22578 0.16933-0.35278 0-0.28222-0.31044-0.32456-0.52211-0.32456-0.08467 0-0.15522 0.01411-0.19756 0.01411h-0.84667c-0.33867 0-0.46567 0.05644-0.73378 0.43744l-1.8062 2.54-1.8909-2.5259c-0.254-0.33867-0.381-0.45156-0.77611-0.45156h-1.0866c-0.22578 0-0.52211 0.02822-0.52211 0.31044 0 0.127 0.09878 0.254 0.16933 0.35278l3.0621 3.9229v0.02822l-3.302 4.5014c-0.07056 0.09878-0.16933 0.22578-0.16933 0.35278z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.fe72e6a57beff324fb55a7fe15f5d7b2.svg";
export { ForwardRef as ReactComponent };